import Axios from "axios";

let aiBaseURL = (process.env.VUE_APP_API_URL || "https://api.arboran.com.br/api/")
  .replace(/\/api\/$/, "/ai-service/api/v1");
if (process.env.NODE_ENV === "development") {
  aiBaseURL = "http://localhost:8000/api/v1";
}

const http = Axios.create({ baseURL: aiBaseURL });
const local = JSON.parse(localStorage.getItem("user-token") || "null");
if (local && local.token) {
  http.defaults.headers.common["Authorization"] = "bearer " + local.token;
}
http.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("user-token");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

class ActionPlanService {
  // ── Templates admin (para modal de importação) ──────────────────────────

  GetTemplates() {
    return http({ url: "/action-plan/templates", method: "GET" });
  }

  // ── Admin — Eixos estratégicos ───────────────────────────────────────────

  AdminListAxes(includeInactive = false) {
    return http({ url: "/admin/action-plan/strategic-axes", method: "GET", params: { include_inactive: includeInactive } });
  }

  AdminCreateAxis(data) {
    return http({ url: "/admin/action-plan/strategic-axes", data, method: "POST" });
  }

  AdminUpdateAxis(id, data) {
    return http({ url: "/admin/action-plan/strategic-axes/" + id, data, method: "PUT" });
  }

  AdminDeleteAxis(id) {
    return http({ url: "/admin/action-plan/strategic-axes/" + id, method: "DELETE" });
  }

  // ── Admin — Programas ────────────────────────────────────────────────────

  AdminListPrograms(axisId = null, includeInactive = false) {
    const params = { include_inactive: includeInactive };
    if (axisId) params.axis_id = axisId;
    return http({ url: "/admin/action-plan/programs", method: "GET", params });
  }

  AdminCreateProgram(data) {
    return http({ url: "/admin/action-plan/programs", data, method: "POST" });
  }

  AdminUpdateProgram(id, data) {
    return http({ url: "/admin/action-plan/programs/" + id, data, method: "PUT" });
  }

  AdminDeleteProgram(id) {
    return http({ url: "/admin/action-plan/programs/" + id, method: "DELETE" });
  }

  AdminListProgramLinks(programId) {
    return http({ url: "/admin/action-plan/programs/" + programId + "/public-programs", method: "GET" });
  }

  AdminAddProgramLink(programId, ppId) {
    return http({ url: "/admin/action-plan/programs/" + programId + "/public-programs/" + ppId, method: "POST" });
  }

  AdminRemoveProgramLink(programId, ppId) {
    return http({ url: "/admin/action-plan/programs/" + programId + "/public-programs/" + ppId, method: "DELETE" });
  }

  AdminImportPrograms(file) {
    const formData = new FormData();
    formData.append("file", file);
    return http({ url: "/admin/action-plan/import", data: formData, method: "POST", headers: { "Content-Type": "multipart/form-data" } });
  }

  // ── Admin — Programas Públicos ───────────────────────────────────────────

  AdminListPublicPrograms(includeInactive = false) {
    return http({ url: "/admin/action-plan/public-programs", method: "GET", params: { include_inactive: includeInactive } });
  }

  AdminCreatePublicProgram(data) {
    return http({ url: "/admin/action-plan/public-programs", data, method: "POST" });
  }

  AdminUploadLogo(ppId, file) {
    const formData = new FormData();
    formData.append("file", file);
    return http({ url: "/admin/action-plan/public-programs/" + ppId + "/logo", data: formData, method: "POST", headers: { "Content-Type": "multipart/form-data" } });
  }

  AdminUpdatePublicProgram(id, data) {
    return http({ url: "/admin/action-plan/public-programs/" + id, data, method: "PUT" });
  }

  AdminDeletePublicProgram(id) {
    return http({ url: "/admin/action-plan/public-programs/" + id, method: "DELETE" });
  }

  // ── Técnico — Eixos estratégicos ─────────────────────────────────────────

  ListAxes(contaId, includeInactive = false) {
    return http({ url: "/action-plan/" + contaId + "/strategic-axes", method: "GET", params: { include_inactive: includeInactive } });
  }

  CreateAxis(contaId, data) {
    return http({ url: "/action-plan/" + contaId + "/strategic-axes", data, method: "POST" });
  }

  UpdateAxis(contaId, axisId, data) {
    return http({ url: "/action-plan/" + contaId + "/strategic-axes/" + axisId, data, method: "PUT" });
  }

  DeleteAxis(contaId, axisId) {
    return http({ url: "/action-plan/" + contaId + "/strategic-axes/" + axisId, method: "DELETE" });
  }

  // ── Técnico — Programas ──────────────────────────────────────────────────

  ListPrograms(contaId, axisId = null, includeInactive = false) {
    const params = { include_inactive: includeInactive };
    if (axisId) params.axis_id = axisId;
    return http({ url: "/action-plan/" + contaId + "/programs", method: "GET", params });
  }

  ListProgramsWithLinks(contaId) {
    return http({ url: "/action-plan/" + contaId + "/programs", method: "GET", params: { with_links: true } });
  }

  CreateProgram(contaId, data) {
    return http({ url: "/action-plan/" + contaId + "/programs", data, method: "POST" });
  }

  UpdateProgram(contaId, programId, data) {
    return http({ url: "/action-plan/" + contaId + "/programs/" + programId, data, method: "PUT" });
  }

  DeleteProgram(contaId, programId) {
    return http({ url: "/action-plan/" + contaId + "/programs/" + programId, method: "DELETE" });
  }

  ImportProgram(contaId, adminProgramId) {
    return http({ url: "/action-plan/" + contaId + "/programs/import/" + adminProgramId, method: "POST" });
  }

  // ── Técnico — Programas Públicos ─────────────────────────────────────────

  ListPublicPrograms(contaId, includeInactive = false) {
    return http({ url: "/action-plan/" + contaId + "/public-programs", method: "GET", params: { include_inactive: includeInactive } });
  }

  CreatePublicProgram(contaId, data) {
    return http({ url: "/action-plan/" + contaId + "/public-programs", data, method: "POST" });
  }

  UploadLogo(contaId, ppId, file) {
    const formData = new FormData();
    formData.append("file", file);
    return http({ url: "/action-plan/" + contaId + "/public-programs/" + ppId + "/logo", data: formData, method: "POST", headers: { "Content-Type": "multipart/form-data" } });
  }

  UpdatePublicProgram(contaId, ppId, data) {
    return http({ url: "/action-plan/" + contaId + "/public-programs/" + ppId, data, method: "PUT" });
  }

  DeletePublicProgram(contaId, ppId) {
    return http({ url: "/action-plan/" + contaId + "/public-programs/" + ppId, method: "DELETE" });
  }

  // ── Técnico — Vínculos ───────────────────────────────────────────────────

  ListProgramLinks(contaId, programId) {
    return http({ url: "/action-plan/" + contaId + "/programs/" + programId + "/public-programs", method: "GET" });
  }

  AddProgramLink(contaId, programId, ppId) {
    return http({ url: "/action-plan/" + contaId + "/programs/" + programId + "/public-programs/" + ppId, method: "POST" });
  }

  RemoveProgramLink(contaId, programId, ppId) {
    return http({ url: "/action-plan/" + contaId + "/programs/" + programId + "/public-programs/" + ppId, method: "DELETE" });
  }

  // ── Exportação ───────────────────────────────────────────────────────────

  ExportExcel(contaId) {
    return http({ url: "/action-plan/" + contaId + "/export", method: "GET", responseType: "blob" });
  }

  // ── Variáveis PMAU (data de início do plano) ─────────────────────────────

  GetVariables(contaId) {
    return http({ url: "/pmau-variables/" + contaId, method: "GET" });
  }

  SaveVariable(contaId, variableId, value) {
    return http({ url: "/pmau-variables/" + contaId, data: [{ variable_id: variableId, value: value || "" }], method: "PUT" });
  }

  // ── Técnico — Progresso de metas ─────────────────────────────────────────

  ListProgress(contaId, programId) {
    return http({ url: "/action-plan/" + contaId + "/programs/" + programId + "/progress", method: "GET" });
  }

  AddProgress(contaId, programId, data) {
    return http({ url: "/action-plan/" + contaId + "/programs/" + programId + "/progress", data, method: "POST" });
  }

  DeleteProgress(contaId, programId, entryId) {
    return http({ url: "/action-plan/" + contaId + "/programs/" + programId + "/progress/" + entryId, method: "DELETE" });
  }
}

export default new ActionPlanService();
